module.exports = __webpack_public_path__ + "static/media/attachment.d40d3c3a.svg";